<mat-toolbar class="mat-elevation-z8">
  {{ 'ADDITIONAL_SERVICE_EDIT.TITLE' | transloco }}
</mat-toolbar>

<mat-dialog-content class="mt-3">
  <form [formGroup]="editAdditionalServiceForm">
    @if (!data.onlyCalendar) {
      <mat-form-field class="" appearance="outline">
        <mat-label>
          {{ 'ADDITIONAL_SERVICE_EDIT.STATUS' | transloco }}
        </mat-label>
        <mat-select formControlName="status">
          @for (status of filteredStatusOptions; track status) {
            <mat-option [value]="status.value">
              {{ status.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="" appearance="outline" (click)="plannedDate.open()">
      <mat-label>
        {{ 'ADDITIONAL_SERVICE_EDIT.PLANNED_DATE' | transloco }}
      </mat-label>
      <input matInput class="date-input" [matDatepicker]="plannedDate" [(ngModel)]="selectedDate"
        [ngModelOptions]="{standalone: true}" [min]="$safeNavigationMigration(data?.parkingFrom)" [max]="$safeNavigationMigration(data?.parkingTill)"
        [matDatepickerFilter]="dateFilter" (dateChange)="onDateChange($event)" />
      <mat-datepicker-toggle matSuffix [for]="plannedDate"></mat-datepicker-toggle>
      <mat-datepicker touchUi #plannedDate></mat-datepicker>
      <mat-icon class="date-cancel-icon" matDatepickerToggleIcon (click)="clearDate($event)">clear</mat-icon>
    </mat-form-field>

    @if (data.additionalService.planned && data.additionalService.status === 'Planned') {
      <div
        style="margin-bottom: 16px; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
        <strong>{{'ADDITIONAL_SERVICE_PLANNING.CURRENT_PLANNED_TIME' | transloco}}:</strong> {{ getDisplayTime() }} on {{
        selectedDate | date:'yyyy-MM-dd' }}
      </div>
    }

    @if (availableTimeSlots.length > 0) {
      <mat-form-field class="" appearance="outline">
        <mat-label>Time Slot</mat-label>
        <mat-select [value]="selectedTimeSlot" (selectionChange)="onTimeSlotChange($event.value)">
          @for (slot of availableTimeSlots; track slot) {
            <mat-option [value]="slot">
              {{ formatTimeSlot(slot) }}
            </mat-option>
          }
        </mat-select>
        @if (data.additionalService.status === 'Planned') {
          <mat-hint
            >{{'ADDITIONAL_SERVICE_PLANNING.SELECT_NEW_PLANNED_TIME' |
          transloco}}</mat-hint>
        }
      </mat-form-field>
    }
  </form>

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-raised-button color="primary" [disabled]="editAdditionalServiceForm.invalid || isLoading"
    (click)="submitForm()">
    <span>
      {{'PRICING.FORM.EDIT' | transloco }}
    </span>
  </button>
  <button mat-button mat-dialog-close [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>